module.exports = "<div class=\"js-button-region\"></div>\n<div class=\"btn-separator\"></div>\n<div class=\"js-popup-region\"></div>\n";